import { useState, useCallback } from 'react';

export const useAnimationLogic = (flightPathLength: number, initialStep = 0) => {
  const [currentStep, setCurrentStep] = useState(initialStep);
  const [isAnimating, setIsAnimating] = useState(false);

  const goToNextStep = useCallback(() => {
    setCurrentStep(prevStep => (prevStep + 1) % flightPathLength);
  }, [flightPathLength]);

  return {
    currentStep,
    isAnimating,
    setIsAnimating,
    goToNextStep,
    setCurrentStep,
  };
};
